import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction, from } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { SiteStructureType } from '@appTypes/siteStructureType';
import { CategoryAppType } from '@appTypes/CategoryAppType';
import { Actions, actions } from '@redux/modules/sitestructure';
import { TypedEpic } from './types';

export const fetchSiteStructureEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_SITESTRUCTURE),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getSiteStructure.request>[]
    >,
    mergeMap(([action]: { payload: string }[]) =>
      from(
        apiClient.get<SiteStructureType>(ApiType.apimNafNoApi, {
          url: ApiPaths[ApiType.apimNafNoApi].sitestructure.get(action.payload),
        }),
      ).pipe(
        map((response) => actions.getSiteStructure.success(response.data, { id: action.payload })),
        catchError((err) =>
          of(
            actions.getSiteStructure.failure(toReduxError(err, 'Could not get sitestructure'), { id: action.payload }),
          ),
        ),
      ),
    ),
  );

export const fetchCategoryAppEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_CATEGORYAPP),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getCategoryApp.request>[]
    >,
    switchMap(([action]) =>
      fromApiRequest((signal) =>
        apiClient.get<CategoryAppType>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].sitestructure.category.app(action.payload.slug, action.payload.app),
        }),
      ).pipe(
        map((response) => actions.getCategoryApp.success(response.data, action.payload)),
        catchError((err) =>
          of(actions.getCategoryApp.failure(toReduxError(err, 'Could not get category app'), action.payload)),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchSiteStructureEpic, fetchCategoryAppEpic];
